import React, {useCallback} from 'react';
import {TextField} from '@mui/material';
import {removeInitialSpecialChars} from '../../../../util/sanitizeUtil';
import {CheckInFieldProps} from '../interfaces';
import {CODE_INPUT_PROPS} from './keyboardInputProps';

/**
 * Driver License Number text field.
 * Uppercases and sanitizes input on every keystroke.
 */
const DriverLicenseNumberField: React.FC<CheckInFieldProps> = ({value, onValueChange, error, required}) => {
  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const sanitized = removeInitialSpecialChars(e.target.value.toUpperCase());
    onValueChange('driverLicenseNumber', sanitized);
  }, [onValueChange]);

  return (
    <TextField
      id="driverLicenseNumber"
      name="driverLicenseNumber"
      label="Driver License Number"
      value={value}
      onChange={handleChange}
      placeholder="Enter the driver's license number"
      variant="standard"
      fullWidth
      required={required}
      error={!!error}
      helperText={error}
      inputProps={{...CODE_INPUT_PROPS, 'aria-label': 'Driver License Number'}}
    />
  );
};

export default DriverLicenseNumberField;

